var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotIncludedIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2181_6662)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6176 20.5H16.5808C16.5531 20.4586 16.5232 20.419 16.4912 20.3813L9.53035 12.9854C9.49318 12.9459 9.45094 12.911 9.40788 12.8704C9.36718 12.911 9.33529 12.9401 9.30541 12.9719C6.98072 15.4415 4.65617 17.9113 2.33176 20.3813C2.29992 20.419 2.27015 20.4586 2.24259 20.5H2.20588C2.10047 20.3827 1.99765 20.2635 1.88918 20.1495C1.2602 19.4843 0.630478 18.8199 0 18.1562L0 18.1172C0.0433695 18.0832 0.0850712 18.0469 0.124941 18.0084C2.44165 15.5479 4.75788 13.0871 7.07353 10.626C7.11118 10.586 7.14412 10.5416 7.18235 10.4954C7.14471 10.4526 7.11718 10.4188 7.08729 10.387C4.76244 7.91683 2.43742 5.44683 0.112235 2.977C0.0765605 2.94336 0.0390863 2.91193 0 2.88287L0 2.84375L2.20588 0.5H2.24271C2.27694 0.54425 2.30788 0.59225 2.34553 0.63225C4.66129 3.09375 6.97718 5.5545 9.29329 8.01463C9.33094 8.05463 9.37271 8.08962 9.41624 8.13025C9.45647 8.09062 9.48835 8.061 9.51824 8.02913C11.8427 5.55938 14.1671 3.08913 16.4913 0.61875C16.5233 0.581043 16.5532 0.541393 16.5808 0.5L16.6176 0.5L18.8235 2.84375V2.88287C18.78 2.91667 18.7383 2.95298 18.6985 2.99162C16.3819 5.45162 14.0659 7.9125 11.7505 10.3734C11.7133 10.413 11.6804 10.4577 11.6422 10.5036C11.6799 10.5469 11.7079 10.5808 11.7402 10.6125C14.0647 13.0823 16.3895 15.5519 18.7147 18.0214C18.75 18.0555 18.7872 18.0875 18.826 18.1172V18.1562L16.6176 20.5Z",
    fill: "#C1CEE8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2181_6662"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotIncludedIcon);
export default __webpack_public_path__ + "static/media/notIncludedIcon.23e39ead96f30fc3134300cbe87c0b4c.svg";
export { ForwardRef as ReactComponent };